module.exports = __webpack_public_path__ + "media/images/ui__infoBox-2428d264b8c9f7cfb8c6ec207c7e59a0.png";